import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import WhyUs from "./components/WhyUs";
import Services from "./components/Services";
import Advantages from "./components/Advantages";
import CTAButton from "./components/CTAButton";
import About from "./pages/About";
import ScrollToTop from "./components/ScrollToTop";
import Faqs from "./pages/Faqs";  // ✅ Correct import name
import ServicesPage from "./pages/ServicesPage";
import "./index.css";
import InfoBar from "./components/InfoBar";
import Contact from "./pages/Contact";
import UmrahTickets from "./pages/UmrahTickets";


function App() {
  return (
    <Router>
       <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-blue-glow text-white">
        <Header />
        <InfoBar />
      

        <main className="flex-grow pt-[65px]">
          <Routes>
            {/* Home Page */}
            <Route
              path="/"
              element={
                <>
                  <Hero /> 
                  <CTAButton />
                  <Services />
                  <WhyUs />
                  <Advantages />
                 
                </>
              }
            />

            {/* Static Pages */}
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/faqs" element={<Faqs />} />  {/* ✅ Correct route name */}
            <Route path="/contact" element={<Contact />} />
            <Route path="/umrahtickets" element={<UmrahTickets />} />

            </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
